import { DataKits, IKitsState } from "../@types";
import { kitsActions } from "../action-types";

type kitsActionType =
| { type: typeof kitsActions.KITS_MODAL_STATE }
| { type: typeof kitsActions.GET_KIT_FOR_UPDATE; payload: DataKits }
| { type: typeof kitsActions.IS_KITS_FOR_UPDATE; payload: boolean }
| { type: typeof kitsActions.SWITCH_KITS_REFRESH_TABLE; payload: boolean }
| { type: typeof kitsActions.SWITCH_KITS_PRODUCTS_REFRESH_TABLE; payload: boolean }

const INITIAL_STATE: IKitsState ={
    kitsForUpdate: undefined,
    isUpdateKit: false,
    kitsModalIsOpen: false,
    refreshTableKits: false,
    refreshTableKitsProducts: false,
}

export default function kitsReducer(state: IKitsState = INITIAL_STATE, action: kitsActionType): IKitsState {
    switch(action.type){
        case kitsActions.KITS_MODAL_STATE:
            return{
                ...state,
                kitsModalIsOpen: !state.kitsModalIsOpen
            }
        case kitsActions.GET_KIT_FOR_UPDATE:
            return{
                ...state,
                kitsForUpdate: action.payload,
            }
        case kitsActions.IS_KITS_FOR_UPDATE:
            return{
                ...state,
                isUpdateKit: action.payload
            }
        case kitsActions.SWITCH_KITS_REFRESH_TABLE:
            return{
                ...state,
                refreshTableKits: action.payload
            }
        case kitsActions.SWITCH_KITS_PRODUCTS_REFRESH_TABLE:
            return{
                ...state,
                refreshTableKitsProducts: action.payload
            }
        default:
            return state
    }
}
